var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 4L10 10M10 10L16 16M10 10L4 16M10 10L16 4","stroke":"white","strokeWidth":"1.25","strokeLinecap":"round"}));
}

Close.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Close;

Close.default = Close;
